import SlatGradientLoop from "../../../../src/videos/slat_gradient_loop.mp4";
import ibmWatson from "../../../../src/pages/design-characteristics/videos/ibm-watson-logo.mp4";
import ImageCollection from "../../../../src/components/ImageCollection";
import * as React from 'react';
export default {
  SlatGradientLoop,
  ibmWatson,
  ImageCollection,
  React
};